import React from 'react';
import { FaqStyle } from './styled';

function FaqBox(props) {
  const { faqsData } = props;
  return (
    <FaqStyle>
      <h2>Frequently Asked Questions</h2>
      {faqsData?.map((element, index) => {
        return (
          <>
            <p className="questionName">{element?.questionName}</p>{' '}
            <p className="ansText">{element?.acceptedAnswerText}</p>
          </>
        );
      })}
    </FaqStyle>
  );
}

export default FaqBox;
